
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 132172","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 132182","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M12.723 3.867L5.699 8.453a3.718 3.718 0 000 6.231l7.024 4.586a4.563 4.563 0 004.6 0l6.987-4.586a3.718 3.718 0 000-6.219l-6.989-4.586a4.535 4.535 0 00-4.598-.012z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.566 16.177l-.012 5.473a3.981 3.981 0 002.544 3.535l3.722 1.237a4.487 4.487 0 002.357 0l3.722-1.237a3.981 3.981 0 002.544-3.536v-5.414M25.967 18.417v-7"}})])])
          )
        }
      }
    